import { types } from 'mobx-state-tree';
import Contact from '../Contact/index';
import Actions from './actions/index';
const Ugc = types
    .model({
    isLoaded: types.optional(types.boolean, false),
    isValid: types.optional(types.boolean, false),
    invalidAnswers: types.optional(types.number, 0),
    shouldCheckDismissLogicOrValid: types.maybeNull(types.boolean),
    shouldShowPopup: types.maybeNull(types.boolean),
    alreadyAnswered: types.maybeNull(types.boolean),
    currentContact: types.maybe(types.reference(Contact)),
    userAnswers: types.optional(types.array(types.string), []),
    numOfAnswers: types.optional(types.number, 0),
})
    .actions(Actions);
export default Ugc;
